import React from 'react';
import './styles.css';
import CardHelper from "../../helpers";
import Device from "../../../../devices/device";

function ImageTalent(props) {
  const platform = Device.getDevice().getPlatform()
  return (
    platform !== "ps4"
      ? <div
        className={`card-cover ${props.classOutLineFocus}`}
        style={{ backgroundImage: `url(${props.cover})`, backgroundSize: 'cover' }}
      />
      : <img
        className={`card-cover ${props.classOutLineFocus}`}
        style={{ boxSizing: "border-box", objectFit: 'cover' }}
        src={props.cover}
        alt={props.title}
      />
  )
}

function CardTalent(props) {
  return (
    <div className={'card card-talent'}>
      <div className={'card-container'}>
        <div className={'preview-container'}>
          {props.cover !== '' &&
            <ImageTalent {...props} />
          }
        </div>
      </div>
      <div className='card-labels-container'>
        { CardHelper.createTitle(props.title || '', true)}
        { CardHelper.createSubTitle(props.subtitle || '')}
      </div>
    </div>
  );
}

export default CardTalent;



// WEBPACK FOOTER //
// ./src/components/CardNew/cardTypes/CardTalents/index.js